import { useMutation, useQueryClient } from "@tanstack/react-query";
import { messageRequestStatusApi } from "api/messageRequestStatusApi";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const useMessageRequestStatus = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: messageRequestStatusApi, // receives variables from mutate()
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["user-request-list"],
        exact: false,
      });

      AlertNotification("success", "Message request updated");

      // 🚀 forward variables so component gets { id, status }
      if (options?.onSuccess) options.onSuccess(data, variables);
    },
    onError: (error, variables) => {
      AlertNotification("error", error.message || "Update failed");

      if (options?.onError) options.onError(error, variables);
    },
  });
};
